<template>
  <!-- 试题按钮 -->
  <div
    :class="productFlag == 1 ? 'platform_jump_btn' : 'platform_jump_btn1'"
    v-if="btnFlag === 'examination'"
  >
    <el-button v-bury="{ start: true }" @click="goStudy()" type="primary" ref="startSoftware" :href="startSoftwareUrl"
    >开始答题
    </el-button>
  </div>
  <div class="paper_preview" v-else-if="btnFlag === 'previewExam'">
    <span class="intoSystem" @click="goStudy()"
    >进入实操系统<img src="/static/images/study/icon/right.png"
    /></span>
  </div>
</template>

<script>
  import * as api from "@/api/courseApi";
  import jumpUtils from "@/utils//platformJump.js";
  import {moduleId} from "../../store/modules/exam";
  import {mapActions} from 'vuex';

  export default {
    props: {
      btnFlag: {
        type: String,
      },
      queryData: {
        type: Object, //路由参数
      },
      questionData: {
        type: Object, //试题参数
      },
    },
    data() {
      return {
        productFlag: sessionStorage.getItem("productFlag"), //课程类型：1.课证融通、2.单项训练、3.综合实训、4.真实任务
        professional: sessionStorage.getItem("professional"), //专业
        templatesArr: [], // 试题内templates
        resourceId: "", //资源/试题 -- id
        startSoftwareUrl: "", //rpa地址
        openShow: false, //是否启动团建
        beforePlatform: {}, //获取各平台跳转域名
        courseId: "",
        //
        childrenBtn: {},
        platformName: [],
        questionDynmaicParam: {},
      };
    },

    created() {
      this.courseId = this.queryData.id;
      // 获取各平台跳转域名
      this.getPlatformPath();
    },
    methods: {
      ...mapActions(moduleId, ['saveAnswer']),
      // 开始学习
      goStudy() {
        if (this.questionData && this.questionData.questionDto && this.questionData.questionDto.internalTypeId === 9) {
          //根据试题ID 获取试题中所有事项的动态参数
          this.getAllparams(this.questionData.questionId);
        }
      },
      startFn(paramsList) {
        //开始跳转
        let platform = this.platformName[0];
        sessionStorage.setItem("childrenUrls", "");
        if (paramsList.length > 0) {
          // let arr = []
          // paramsList.forEach((v) => {
          //   if (v.key === "platform") {
          //     platform = v.value;
          //     arr.push({
          //       id: v.eventId,
          //       sort: v.sort,
          //     })
          //   }
          // });
          let userId = "";
          let cstr = this.queryData.examId + sessionStorage.getItem("userId");
          if (cstr.length < 13) {
            userId = cstr.padEnd(13, "0");
          } else {
            userId = cstr;
          }
          let templates = []
          let dummyProObj = {}

          if (platform === 'dummyPro') {
            let eventUrl = this.questionData.questionDto.eventTemplate.eventUrl
            let url = eventUrl.split('?')[0].split('cailian.net')[1]
            // let param = eventUrl.split('?')[1]
            dummyProObj = {
              eventDesp: url,
              eventTemplateUrl: url,
              eventUrl: eventUrl
            }
            templates.push(dummyProObj)
          } else if (platform === 'BusinessAnalyticsOS') {//商务数据分析
            let eventUrl = this.questionData.questionDto.eventTemplate.eventUrl
            dummyProObj = {
              eventParam: eventUrl,
            }
            templates.push(dummyProObj)
            userId = sessionStorage.getItem("userId");
          } else if (this.questionData.questionDto.eventTemplates && this.questionData.questionDto.eventTemplates.length) {
            this.questionData.questionDto.eventTemplates.forEach(item => {
              templates.push({
                roles: item.roles,
                eventParam: item.eventUrl,
                eventTemplateUrl: item.eventUrl,
                formPage: '来源共享中心的考试或测评',
              })
            })
          }
          // else if (platform === 'ExcelOS_Bak') {//商务数据分析
          //   templates = arr
          // }
          let jumpObj = {
            token: localStorage.getItem("Authorization"), // token
            productFlag: sessionStorage.getItem("productFlag"), // 产品标识：1、书证融通，2、单项训练，3、综合实训，4、真实任务
            courseId: this.courseId, // 课程id
            courseName: sessionStorage.getItem("courseName"), // 课程名称
            classId: this.$route.query.classId, // 班级id
            className: this.$route.query.className, // 班级名称
            platform: platform, // 平台标识
            paramsList: paramsList, //
            listItem: {
              templates: templates,
              id: this.questionData.questionId,
              paperId: this.queryData.paperId,
              model: "cy",
            }, // 试题参数集合
            // myStation: that.myStation,// 我的岗位
            deptId: sessionStorage.getItem("deptId"), // 机构id
            deptName: sessionStorage.getItem("deptName"), // 机构名称
            userId: userId, // 用户id
            username: sessionStorage.getItem("userName"), // 账号
            nickname: sessionStorage.getItem("loginName"), // 用户姓名
            userType: sessionStorage.getItem("userType"), // 用户类型
            mobile: sessionStorage.getItem("mobile"), // 手机号
            timestamp: new Date().getTime(),
            teamId: "",
            teamName: "",
            stationList: [],
            //====================================
            sex: sessionStorage.getItem("sex"), // 性别
            headImgUrl: "", // 头像
            idCard: "", // 身份证
            password: "e10adc3949ba59abbe56e057f20f883e",
            // item: ${questionDto.questionCode},
            item: "27011201-6fe9-46b4-ba7f-fe241aed2132", // questionCode
            clientId: "1349883712819109890",
            questionDto: this.questionData.questionDto,
            professional: this.professional,
          };
          if (this.platformName[0] === 'RPAOS') {
            this.startIforame(jumpObj);
          } else if (this.btnFlag === "examination" || this.btnFlag === "previewExam") {
            this.plateformJump(jumpObj); //平台跳转
          }

        } else {
          this.$messageError("该任务发生了修改。请通知该【课程创建人】重新发布课程后，刷新当前任务。");
        }
      },
      plateformJump(jumpObj) {
        //平台跳转
        let that = this;
        let newObj = {
          beforePlatform: this.beforePlatform,
          ...jumpObj,
        };

        // 判断是否有子事项，获取子事项跳转地址
        if (
          this.childrenBtn.length
        ) {
          let childrenPromise = [];
          let childrenUrls = [];
          [].forEach.call(this.childrenBtn, (platformIndex) => {

            if (this.platformName[platformIndex]) {

              let list = [];
              this.questionDynmaicParam[platformIndex].map((item) => {
                let obj = {
                  key: item.param,
                  value: item.value,
                };
                list.push(obj);
              });

              let childObj = {
                ...jumpObj,
                platform: this.platformName[platformIndex],
                beforePlatform: this.beforePlatform,
                paramsList: list,
              };

              if (this.platformName[platformIndex] === 'RPAOS') {
                childrenPromise.push(jumpUtils.rpaJump(childObj));
              } else {
                childrenPromise.push(jumpUtils.plateformJump(childObj, platformIndex));
              }

              childrenUrls.push({
                platform: this.platformName[platformIndex],
                childIframeUrl: "",
              });

            }
          });

          Promise.all(childrenPromise).then((children) => {

            [].forEach.call(children, (citem, cindex) => {
              if (citem && citem.iframeUrl) {
                childrenUrls[cindex]["childIframeUrl"] = citem.iframeUrl;
              }
            });

            sessionStorage.setItem("childrenUrls", JSON.stringify(childrenUrls));
            jumpUtils.plateformJump(newObj).then((data) => {
              if (data.iframeUrl) {
                that.$emit('jumpStudy', data, newObj)
                // that.$parent.endJump(data, newObj);
              }
            });
          });
        } else {
          jumpUtils.plateformJump(newObj).then((data) => {
            if (data.iframeUrl) {
              that.$emit('jumpStudy', data, newObj)
              // that.$parent.endJump(data, newObj);
            } else {
              this.$messageError("跳转地址获取失败");
            }
          });
        }
      },

      //============================启动RPA===========================
      async startIforame(jumpObj) {
        let that = this;
        jumpUtils.rpaJump(jumpObj).then((data) => {
          that.startSoftwareUrl = data.iframeUrl;
          that.$nextTick(() => {
            if (this.$refs.startSoftware[0]) {
              window.protocolCheck(
                data.iframeUrl,
                function () {
                  var answer = confirm("检测到未安装编辑器，是否下载？");
                  if (answer) {
                    window.location = data.downloadUrl;
                    that.openShow = false;
                  } else {
                    that.openShow = false;
                    alert("已取消下载编辑器，无法启动。");
                  }
                }
              );
            } else {
              window.protocolCheck(
                data.iframeUrl,
                function () {
                  var answer = confirm("检测到未安装编辑器，是否下载？");
                  if (answer) {
                    window.location = data.downloadUrl;
                    that.openShow = false;
                  } else {
                    that.openShow = false;
                    alert("已取消下载编辑器，无法启动。");
                  }
                }
              );
            }

            that.openShow = true;
            // event.preventDefault
            //   ? event.preventDefault()
            //   : (event.returnValue = false);
          });
        });
      },

      //根据试题ID 获取试题中所有事项的动态参数
      getAllparams(id) {
        api
          .getQuestionDynmaicParam(id)
          .then((rs) => {
            if (rs.code === "0") {
              if (rs.data) {
                let list = [];
                this.questionDynmaicParam = rs.data;
                for (const i in rs.data) {
                  let event = rs.data[i];
                  [].forEach.call(event, (item) => {
                    if (item.param === "platform") {
                      this.platformName.push(item.value);
                    }
                  });
                }
                rs.data[0].map((item) => {
                  let obj = {
                    key: item.param,
                    value: item.value,
                    sort: item.sort,
                    eventId: item.eventId,
                  };
                  list.push(obj);
                });
                console.log('》》跳转平台platform：', this.beforePlatform, this.platformName)
                //  获取试题的事项，用于获取主子关系
                this.getQuestionEvent(id, list);

              } else {
                console.error('--getAllparams--', '未获取到跳转参数')
              }
            } else {
              this.$messageError(rs.msg);
            }
          })
          .catch(error => {
            console.error('--getAllparams--', error)
          });
      },

      //  获取试题的事项，用于获取主子关系
      getQuestionEvent(id, list) {
        api.getQuestionEventById(id).then((res) => {
          if (res.code == 0) {
            if (res.data && res.data.length) {
              let child = [];
              let o = {};
              let setObj = {}; // 重复项
              let pretendChild = ['BigDataOS', 'ExcelOS', 'ExcelCustomOS', 'FZBAOSHUI', 'RPAOS']; // 伪子级
              [].forEach.call(res.data, item => {

                if (pretendChild.includes(this.platformName[item.sort])) {
                  if (item.sort === 0) return
                  if (!setObj[this.platformName[item.sort]]) {
                    setObj[this.platformName[item.sort]] = 1
                  } else {
                    setObj[this.platformName[item.sort]]++
                  }
                  if (setObj[this.platformName[item.sort]] && setObj[this.platformName[item.sort]] === 1) {
                    child.push(item.sort)
                  }

                } else if (item.parentId) {
                  if (o[item.parentId]) {
                    if (!setObj[this.platformName[item.sort]]) {
                      setObj[this.platformName[item.sort]] = 1
                    } else {
                      setObj[this.platformName[item.sort]]++
                    }
                    if (setObj[this.platformName[item.sort]] && setObj[this.platformName[item.sort]] === 1) {
                      child.push(item.sort)
                    }
                  } else {
                    o[item.parentId] = true;
                  }
                }
              })

              this.childrenBtn = [...child];
              // 去学习
              this.startFn(list);
            }
          }
        });
      },
      // 获取各平台跳转域名
      getPlatformPath() {
        api.getPlatformPath(this.courseId).then((rs) => {
          if (rs.code == 0) {
            this.beforePlatform = {};
            if (rs.data.length > 0) {
              rs.data.forEach((v) => {
                v.platformPathList.forEach((val) => {
                  if (val.isBind == 1) {
                    this.beforePlatform = {
                      urlPath: val.urlPath,
                      platform: v.platformTag,
                      code: val.code,
                      tag: val.tag
                    }
                    return
                  }
                });
              });
            }
          } else {
            this.$messageError(rs.msg);
          }
        });
      },

      //跳转前查询userId
      queryResetExercise() {
        let param = {
          classId: this.$route.query.classId,
          courseId: this.$route.query.courseId,
          catalogId: this.$route.query.catalogId,
          resourceId: this.questionData.questionId,
        };
        return new Promise((resolve) => {
          api.queryResetExercise(param).then((rs) => {
            if (rs.code === "0") {
              resolve(rs.data);
            } else {
              this.$messageError(rs.msg);
            }
          });
        });
      },

      async isTeam() {
        return api
          .jumpstx(this.courseId, this.$route.query.classId)
          .then((res) => res);
      },

    },
  };
</script>
<style lang="scss">
  .platform_jump_btn1 {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .task_btn {
      width: 80px;
      height: 30px;
      border: 1px solid #5397f7;
      color: #5397f7;
      border-radius: 4px;
      box-sizing: border-box;
      text-align: center;
      line-height: 28px;
      padding: 0;
      cursor: pointer;
    }

    button {
      padding: 8px 10px 8px 30px;
      position: relative;
      background: #fff;
      border: 1px solid #5397f7;
      color: #5397f7;

      &::after {
        content: "";
        width: 16px;
        height: 16px;
        background: url("../views/studyCenter/img/start.png");
        background-size: 16px 16px;
        position: absolute;
        left: 10px;
        top: 7px;
      }

      &:hover {
        color: #fff;
        background: #5397f7;

        &::after {
          background: url("../views/studyCenter/img/start-hv.png");
          background-size: 16px 16px;
        }
      }
    }
  }

  .platform_jump_btn {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    button,
    .task_btn {
      width: 120px;
      height: 40px;
      line-height: 40px;
      padding: 0;
      background: linear-gradient(135deg, #1890ff 0%, #00b3f7 100%, #00b3f7 100%);
      border-radius: 24px;
      border: none;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      cursor: pointer;

      &:hover {
        background: linear-gradient(
            135deg,
            #1890ff 0%,
            #00b3f7 100%,
            #00b3f7 100%
        );
        border-radius: 24px;
        border: none;
        opacity: 0.8;
      }
    }
  }

  .paper_preview {
    display: inline-block;
    margin-left: 40px;

    .intoSystem {
      color: #5397f7;
      font-size: 14px;
      cursor: pointer;

      img {
        display: inline-block;
        width: 10px;
        height: 10px;
        margin-left: 4px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/platformBtn/examination.vue